import {
  GET_MALWARE_SCAN_LOGS,
  GET_MALWARE_SCAN_LOGS_SUCCESSFUL,
  GET_MALWARE_SCAN_LOGS_FAILED,
  CLEAR_ALL_MALWARE_SCAN_LOGS_SUCCESSFUL,
} from "./actionTypes";

const initialState = {
  getMalwareScanLogsMessage: null,
  getMalwareScanLogsError: null,
  malwareScanLogsGetting: false,
};

const malwareScan = (state=initialState, action) => {
  switch (action.type) {
    case GET_MALWARE_SCAN_LOGS:
      state = {
        ...state,
        malwareScanLogsGetting: true,
        getMalwareScanLogsMessage: null,
        getMalwareScanLogsError: null,
      }
      break;
    case GET_MALWARE_SCAN_LOGS_SUCCESSFUL:
      state = {
        ...state,
        malwareScanLogsGetting: false,
        getMalwareScanLogsMessage: "Malware scan logs received!",
        malwareLogs: action.payload.malwareLogs
      }
      break;
    case GET_MALWARE_SCAN_LOGS_FAILED:
      state = {
        ...state,
        malwareScanLogsGetting: false,
        getMalwareScanLogsError: action.payload.getMalwareScanLogsError
      }
      break;
    case CLEAR_ALL_MALWARE_SCAN_LOGS_SUCCESSFUL:
      state = {
        ...state,
        getMalwareScanLogsMessage: null,
        getMalwareScanLogsError: null,
      }
      break;      
    default:
      return state;
  }
  return state;
}

export default malwareScan;